<template>
  <nav
    v-if="$route.path !== '/admin-page'"
    class="secondary-nav"
    :class="{ open: isOpen }"
    @click="toggleMenu"
  >
    <div class="secondary-nav__wrapper">
      <ul class="secondary-nav__links-container">
        <li
          class="secondary-nav__links"
          :key="item.id"
          v-for="item in navItems"
          :class="{'secondary-nav__active': $route.path == item.route }"
        >
          <router-link :to="item.route" class="link link--green">
            {{item.title}}
          </router-link>
        </li>
      </ul>

      <span v-show="!isOpen">
        <i class="secondary-nav__icon fas fa-chevron-circle-up"></i>
      </span>

      <span v-show="isOpen">
        <i class="secondary-nav__icon fas fa-chevron-circle-down"></i>
      </span>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'SecondaryNav',
  data() {
    return {
      navItems: [
        { id: 0, title: 'Välkommen', route: '/' },
        { id: 1, title: 'Sammanställning', route: '/overview' },
        { id: 2, title: 'Analys', route: '/pension' },
        { id: 3, title: 'Fastighetsvärdering', route: '/property-valuation' },
        { id: 4, title: 'Målbild', route: '/target' },
        { id: 5, title: 'Prognos', route: '/progress' },
        { id: 6, title: 'Försäkringar', route: '/insurances' },
      ],
      isOpen: false,
    }
  },
  methods: {
    toggleMenu () {
      this.isOpen = !this.isOpen
    },
  }
}
</script>

<style lang="scss" scoped>
.secondary-nav {
    width: 100%;
    background-color: $light;
    height: 4.4rem;
    overflow: hidden;
    transition: height .2s;

    &__wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      max-width: $maxWidth;
      margin: 0 auto;
    }

    &.open {
      height: 485px;
    }

    &__links-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 80%;
      list-style: none;
      margin: 0;
      padding: 0;
    }

    &__links {
      width: 90%;
      padding: 1.5rem 0;
      text-align: center;

      .link {
        padding-bottom: 2px;
        border-bottom: 2px solid transparent;
        transition: all .3s;

        &:hover {
          border-bottom: 2px solid $green;
        }
      }
    }

    &__icon {
      margin: 25px 20px auto 0;
      color: $green;
      font-size: 1.25rem;
      cursor: pointer;
    }

    &__active {
      order: -1;

      .link {
        border-bottom: 2px solid $green;
      }
    }

    @include breakpoints(xLarge) {
      height: 6em;

      &.open {
        height: 6em;
      }

      &__links-container {
        flex-direction: row;
      }

      &__icon {
        display: none;
      }

      &__active {
        order: initial;
      }
    }
  }
</style>